import React from 'react'
import { Box, Flex, Text, Button } from 'rebass'

const ErrorScreen = ({
    title = 'Something went wrong',
    description = 'We couldn’t process your order. Please refresh or try again later.',
    onRetry,
    retryButtonText = "Contact Us"
}) => {
    return (
        <Flex
            height="100vh"
            alignItems="center"
            justifyContent="center"
            px={3}
        >
            <Box textAlign="center" maxWidth="500px">
                <Text fontSize={3} fontWeight="600" mb={2}>
                    {title}
                </Text>

                <Text fontSize={1} color="gray" mb={3}>
                    {description}
                </Text>

                {onRetry && (
                    <Button
                        onClick={onRetry}
                        sx={{
                            cursor: 'pointer'
                        }}
                    >
                        {retryButtonText}
                    </Button>
                )}
            </Box>
        </Flex>
    )
}

export default ErrorScreen
